export default __webpack_public_path__ + "static/media/GAN3.b1c2e4d2.png";